import { notif } from '../notification-service';
import { Logger } from '../global/logger';
const logger = new Logger("service", "GraphqlApiBase");
export class GraphqlApiBase {
    constructor() {
        this.backend = location.origin + "/graphql";
    }
    /**
     * Make a GraphQL API call.
     *
     * @param query - The GraphQL query to send.
     * @param vars - Optional variables to include in the query.
     * @param noNotif - Set to true to suppress notifications in case of errors.
     * @returns A Promise that resolves with the API response or rejects with an error.
     */
    async call(query, vars = null, noNotif = false) {
        var body = { query: query };
        if (vars) {
            body["variables"] = vars;
        }
        try {
            const response = await this.post(body);
            if (response.ok) {
                var retv = await response.json();
                if (retv.errors) {
                    logger.error("gql error", retv);
                    if (!noNotif) {
                        const notifInput = graphqlErrorToNotif(retv);
                        notif(notifInput.title, notifInput.body);
                    }
                    return Promise.reject(retv.errors);
                }
                return retv;
            }
            else {
                if (!noNotif) {
                    notif("Request Error", `${response.status} - ${response.statusText}`);
                }
                logger.debug(query, response);
                return { error: response };
            }
        }
        catch (exc) {
            if (!noNotif) {
                notif("Request Exception", exc);
            }
            return { exception: exc };
        }
    }
    /**
     * Send a POST request to the GraphQL API endpoint.
     *
     * @param body - The request body to send in the POST request.
     * @returns A Promise that resolves with the response from the server.
     */
    async post(body) {
        return await fetch(this.backend, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify(body),
        });
    }
}
/**
* Convert GraphQL errors to notification data.
*
* @param res - The GraphQL API response.
* @returns An object containing notification title and body.
*/
export const graphqlErrorToNotif = (res) => {
    var _a, _b;
    let title;
    const body = [];
    if (res.errors) {
        title = 'Error';
        for (const e of res.errors) {
            let b = [];
            b.push('<b>Code</b>: ' + ((_a = e.extensions) === null || _a === void 0 ? void 0 : _a.code));
            b.push('<b>Path</b>: ' + ((_b = e.path) === null || _b === void 0 ? void 0 : _b.join('/')));
            b.push(`<b>Message</b>: <code><verbatim>${e.message}</verbatim></code>`);
            body.push(b.join('<br/>'));
        }
    }
    else {
        title = "Request Exception";
        body.push(res.exception);
    }
    return { title: title, body: body.join('<br/><br/>') };
};
